<template>
  <div>
    <v-breadcrumbs :items="items"></v-breadcrumbs>
    <form v-on:submit.prevent="submitForm">
      <v-row>
        <v-col cols="3">
          <v-card>
            <v-card-title>
              OT Registration: {{ op_registration.registration_no }}
              <v-spacer></v-spacer>
            </v-card-title>
            <v-col cols="12">
              <v-simple-table dense>
                <template v-slot:default>
                  <tbody>
                  <tr>
                    <td>OT Name</td>
                    <td>:</td>
                    <td class="">{{ operation.name }}</td>
                  </tr>
                  <tr>
                    <td>OT Type</td>
                    <td>:</td>
                    <td class="">{{ operation.op_type }}</td>
                  </tr>
                  <tr>
                    <td>Doctor:</td>
                    <td>:</td>
                    <td class="">{{ doctor.dr_name }}</td>
                  </tr>
                  <tr>
                    <td>OT Date</td>
                    <td>:</td>
                    <td class="">
                      <v-menu
                          v-model="menu2"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                              v-model="date"
                              label="Select Date"
                              prepend-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              outlined
                              dense
                              hide-details
                          ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="date"
                            @input="menu2 = false"
                        ></v-date-picker>
                      </v-menu>
                    </td>
                  </tr>
                  <tr>
                    <td>OT Amount</td>
                    <td>:</td>
                    <td class="">{{ op_registration.ot_amount }}</td>
                  </tr>
                  <tr>
                    <td>Paid Amount</td>
                    <td>:</td>
                    <td class="">{{ op_registration.paid_amount }}</td>
                  </tr>
                  <tr>
                    <td>Hospital</td>
                    <td>:</td>
                    <td class="">{{ op_registration.hospital_amount }}</td>
                  </tr>
                  <tr>
                    <td>Doctor</td>
                    <td>:</td>
                    <td class="">{{ op_registration.doctor_amount }}</td>
                  </tr>

                  <tr>
                    <td>Discount Amount</td>
                    <td>:</td>
                    <td>
                      <v-text-field
                          v-model="discount_amount"
                          outlined
                          dense
                          hide-details
                      ></v-text-field>
                    </td>
                  </tr>

                  <tr>
                    <td>Due Allow</td>
                    <td>:</td>
                    <td>{{ op_registration.proposed_due_amount }}</td>
                  </tr>

                  <tr>
                    <td>Paid Amount</td>
                    <td>:</td>
                    <td>{{ op_registration.paid_amount }}</td>
                  </tr>
                  <tr>
                    <td>Due Balance</td>
                    <td>:</td>
                    <td color="red">
                      <v-chip color="red" text-color="white">
                        {{ op_registration.due_amount }}
                      </v-chip
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>Status</td>
                    <td>:</td>
                    <td class="">{{ op_registration.opp_status }}</td>
                  </tr>
                  <tr>
                    <td>Eye</td>
                    <td>:</td>
                    <td class="">
                      <v-select
                          v-model="eye_type"
                          item-text="name"
                          :items="eyeTypes"
                          label="Eye Type"
                          dense
                          outlined
                      ></v-select>
                    </td>
                  </tr>
                  </tbody>
                </template>
              </v-simple-table>

              <div class="text-right">
                <v-btn
                    small
                    color="primary"
                    type="submit"
                    v-if="op_registration.opp_status == 'open'"
                >Update
                </v-btn
                >
              </div>
            </v-col>
          </v-card>
        </v-col>
        <v-col cols="3">
          <v-card dark :loading="loading">
            <v-card-title>
              Patient Info
              <v-spacer></v-spacer>
            </v-card-title>
            <v-simple-table dense>
              <template v-slot:default>
                <tbody>
                <tr>
                  <td>Patient ID</td>
                  <td>:</td>
                  <td class="">{{ patient_info.patient_id }}</td>
                </tr>
                <tr>
                  <td>Name</td>
                  <td>:</td>
                  <td class="">{{ patient_info.patient_name }}</td>
                </tr>
                <tr>
                  <td>Age</td>
                  <td>:</td>
                  <td class="">{{ patient_info.patient_age }}</td>
                </tr>
                <tr>
                  <td>Phone</td>
                  <td>:</td>
                  <td class="">{{ patient_info.patient_phone }}</td>
                </tr>
                <tr>
                  <td>Created at</td>
                  <td>:</td>
                  <td class="">{{ patient_info.create_date }}</td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>

          <v-card>
            <v-card-title>
              Schedule Details
              <v-spacer></v-spacer>
            </v-card-title>
            <v-col cols="12">
              <v-simple-table dense>
                <template v-slot:default>
                  <tbody v-if="submitData">
                  <tr>
                    <td>Doctor</td>
                    <td>:</td>
                    <td class="" v-if="submitData.doctor">{{ submitData.doctor.dr_name }}</td>
                  </tr>
                  <tr>
                    <td>OT Start Time</td>
                    <td>:</td>
                    <td class="">{{ submitData.starting_time }}</td>
                  </tr>
                  <tr>
                    <td>Note</td>
                    <td>:</td>
                    <td class="">{{ submitData.note }}</td>
                  </tr>
                  <tr>
                    <td>Cabin</td>
                    <td>:</td>
                    <td class="">{{ submitData.cabine }}</td>
                  </tr>
                  <tr>
                    <td>OT Amount</td>
                    <td>:</td>
                    <td class="">{{ submitData.amount }}</td>
                  </tr>
                  <tr>
                    <td>OT Due Amount</td>
                    <td>:</td>
                    <td class="">{{ submitData.due_amount }}</td>
                  </tr>
                  <tr>
                    <td>Family Member</td>
                    <td>:</td>
                    <td class="">{{ submitData.family_member_name }}</td>
                  </tr>
                  <tr>
                    <td>Family Member Contact</td>
                    <td>:</td>
                    <td class="">{{ submitData.family_contact_no }}</td>
                  </tr>
                  <tr>
                    <td>Family Member Relation</td>
                    <td>:</td>
                    <td class="">{{ submitData.family_member_relation }}</td>
                  </tr>
                  <tr>
                    <td>Counselor Name</td>
                    <td>:</td>
                    <td class="" v-if="submitData.counselor">{{ submitData.counselor.full_name }}</td>
                  </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
            <v-row align="center" justify="space-around">
              <v-btn
                  v-if="op_registration.schedule_id && op_registration.opp_status == 'open'"
                  depressed
                  color="primary"
                  @click="ot_schedule(op_registration.schedule_id)"
              >
                Edit
              </v-btn>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="4">
          <v-card>
            <form v-on:submit.prevent="receivedMoney">
              <v-col>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field
                        v-model="receive_amount"
                        label="Receive Amount"
                        outlined
                        clearable
                        dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-select
                        v-model="payment_method"
                        item-text="name"
                        :items="paymentMethods"
                        label="Payment Method"
                        outlined
                        dense
                        :rules="[(v) => !!v || 'Payment Method is required']"
                        required
                    ></v-select>
                    <div class="text-right">
                      <v-btn small color="primary" type="submit">Submit</v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </form>
          </v-card>
          <v-spacer></v-spacer>

          <v-card :loading="loading">
            <v-card-title>
              Invoice Info
              <v-spacer></v-spacer>
            </v-card-title>

            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                <tr>
                  <th class="text-left">Invoice ID</th>
                  <th class="text-left">Paid Amount</th>
                  <th class="text-left">Status</th>
                  <th class="text-left">Date</th>
                  <th class="text-left">Reg. No</th>
                  <th class="text-left">Created By</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in invoices" :key="item.invoice_id">
                  <td>{{ item.invoice_id }}</td>
                  <td class="text-right">{{ item.paid_amount }}</td>
                  <td>{{ item.status }}</td>
                  <td>{{ item.create_date }}</td>
                  <td>{{ item.item_name_operation }}</td>
                  <td>{{ item.user.full_name }}</td>
                </tr>
                <tr>
                  <td>Total</td>
                  <th class="text-right">{{ invoice_total | currency }}</th>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
          <v-card-title>
            OT Bill
            <v-spacer></v-spacer>
          </v-card-title>
          <v-data-table
              :headers="headers"
              :items="desserts"
              class="elevation-1"
              :loading="loading"
              dense
          >
            <template v-slot:item.status="{ item }">
              <v-chip small :color="getColor(item.status)" dark>
                {{ item.status.toUpperCase() }}
              </v-chip>
            </template>
            <template v-slot:no-data>
              <v-btn color="primary" @click="initialize">Reset</v-btn>
            </template>
          </v-data-table>
        </v-col>
        <v-col cols="2">
          <v-row>
            <v-col cols="12">
              <template>
                <v-btn
                    small
                    color="warning"
                    @click="discharge_certificate()"
                >Discharge Certificate

                </v-btn>
              </template>
            </v-col>
          </v-row>
          <v-col cols="2">
            <template>
              <v-btn
                  color="info"
                  :disabled="op_registration.opp_status == 'close' ? false : true"
                  @click="otbill_patient_copy(op_registration)"
              >OT BILL: Patient Copy
              </v-btn>
            </template>
          </v-col>

          <v-col cols="2">
            <template>
              <v-btn
                  color="info"
                  :disabled="op_registration.opp_status == 'close' ? false : true"
                  @click="otbillview()"
              >
                OT BILL: Doctor Copy
              </v-btn>
            </template>
          </v-col>
          <!-- <v-col cols="2">
            <template>
              <v-btn
                color="info"
                :disabled="op_registration.opp_status != 'cancel' ? false : true"
                @click="receive_money(op_registration.registration_no)"
              >
                Receive Money
              </v-btn>
            </template>
          </v-col> -->
          <v-col cols="2">
            <template>
              <v-btn
                  color="success"
                  :disabled="op_registration.opp_status == 'open' ? false : true"
                  @click="reGenerate()"
              >
                Bill Generate
              </v-btn>
            </template>
          </v-col>
          <v-col cols="2">
            <template>
              <v-btn
                  color="success"
                  :disabled="
                  operation.op_type != 'Operation' && op_registration.opp_status == 'open'
                    ? false
                    : true
                "
                  @click="autoGenerate()"
              >
                Auto-Generate
              </v-btn>
            </template>
          </v-col>
          <v-col cols="2">
            <template v-if="op_registration.opp_date == nowDate">
              <v-btn
                  color="warning"
                  :disabled="op_registration.opp_status == 'close' ? false : true"
                  @click="reGenerate()"
              >
                Bill Re-Generate
              </v-btn>
            </template>
          </v-col>

          <!-- <v-col cols="2">
            <template>
              <v-btn
                color="primary"
                :disabled="op_registration.opp_status != 'cancel' ? false : true"
                @click="ot_refund()"
              >
                Refund to Patient
              </v-btn>
            </template>
          </v-col> -->
          <v-row>
            <v-col cols="2">
              <template v-if="user_id == 50 || user_id == 1 || user_id == 61 || user_id == 55">
                <v-btn
                    color="error"
                    :disabled="op_registration.opp_status != 'cancel' ? false : true"
                    @click="dialog = true"
                >
                  OT Cancel
                </v-btn>
              </template>
            </v-col>
          </v-row>
          <v-card v-if="op_registration.opp_status == 'cancel'">
            <v-card-title>Cancel details</v-card-title>
            <v-card-text>{{ op_registration.cancel_description }}</v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </form>
    <v-col cols="8"></v-col>
    <template>
      <div class="text-center">
        <v-dialog v-model="dialog" persistent width="500">
          <v-card>
            <v-card-title class="text-h5 grey lighten-2">
              OT Cancel: {{ op_registration.registration_no }}
            </v-card-title>
            <v-card-text>
              <v-simple-table dense>
                <template v-slot:default>
                  <tbody>
                  <tr>
                    <td>OT Date</td>
                    <td>:</td>
                    <td class="">{{ op_registration.opp_date }}</td>
                  </tr>
                  <tr>
                    <td>Paid Amount</td>
                    <td>:</td>
                    <td class="">{{ op_registration.paid_amount }}</td>
                  </tr>
                  <tr>
                    <td>Hospital</td>
                    <td>:</td>
                    <td class="">{{ op_registration.hospital_amount }}</td>
                  </tr>
                  <tr>
                    <td>Doctor</td>
                    <td>:</td>
                    <td class="">{{ op_registration.doctor_amount }}</td>
                  </tr>
                  <tr>
                    <td>Status</td>
                    <td>:</td>
                    <td class="">{{ op_registration.opp_status }}</td>
                  </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-text-field
                  v-model="formdata.reg_no"
                  label="Registration No"
                  outlined
              ></v-text-field>
              <v-textarea
                  outlined
                  v-model="formdata.description"
                  name="input-7-4"
                  label="Description"
              ></v-textarea>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="warning" text @click="dialog = false"> Cancel</v-btn>
              <v-btn color="primary" text @click="otCancel()"> Submit</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </template>
  </div>
</template>

<style scoped>
.layout {
  display: inline-block;
  width: 100%;
}
</style>
<script>
import atshq from "../../../../js/setup";
import "vuejs-noty/dist/vuejs-noty.css";

export default {
  data() {
    return {
      reference_images: null,
      errorMessage: [],
      success: false,
      successMessage: [],
      submitButton: false,
      upload_image: {},
      preview_image: null,
      loadingstatus: false,
      dialog: false,
      date: new Date().toISOString().substr(0, 10),
      nowDate: new Date().toISOString().substr(0, 10),
      menu2: false,
      patient_info: {patient_name: null},
      doctor: {patient_name: null},
      operation: {patient_name: null},
      op_registration: {patient_name: null},
      patient_reg_no: this.$route.params.id,
      surgeonList: [],
      receive_amount: 0,
      refund_note: "",
      loading: true,
      user_id: localStorage.getItem("userId"),
      formdata: {reg_no: null, description: null},
      eyeTypes: ["Left Eye", "Right Eye", "Both Eye", "Left", "Right", "Both"],
      eye_type: "",
      discount_amount: 0,
      payment_method: "Cash",
      paymentMethods: ["Cash"],
      headers: [
        {text: "Head", value: "invoice_description"},
        {text: "Amount", value: "invoice_amount"},

        {text: "Status", value: "status"},
        {text: "Date", value: "date"},
        {text: "Created By", value: "user.first_name"},
      ],
      desserts: [],
      invoices: [],
      errors: [],
      invoice_total: 0,
      ledgerHead: [],
      submitData: {
        id: null,
        patient_id: null,
        surgeon_id: null,
        patient_name: null,
        patient_phone: null,
        patient_sex: null,
        patient_dob: null,
        referral_doctor_id: null,
        operation_id: null,
        operation_subhead: null,
        eye_type: null,
        operation_date: new Date().toISOString().substr(0, 10),
        starting_time: null,
        iol: null,
        iol_power: null,
        amount: null,
        due_amount: null,
        ot_no: null,
        cabine: null,
        note: null,

        family_member_name: null,
        family_contact_no: null,
        family_member_relation: null,

        counselor_id: null,
        counselor: {},
      },
      rules: [
        (value) => !!value || "Required.",
        (value) => (value && value.length >= 1) || "Min 3 characters",
      ],
      numberRule: (val) => {
        if (val < 0) return "Please enter a positive number";
        return true;
      },
      items: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
        },
        {
          text: "OT Bill Receive",
          disabled: true,
          href: "patients",
        },
      ],
      returnUrl: atshq.defaults.headers.common.app_URL,
      returnApiUrl: atshq.defaults.headers.common.api_URL,
      apiBaseUrl: atshq.defaults.headers.common.api_base_URL,
    };
  },
  // Fetches posts when the component is created.
  created() {
    this.loadingstatus = true;
    this.initialize();
    this.getOtBill();
    this.getPaymentMethod();

  },
  methods: {


    ot_schedule(item_id) {
      window.location.href = "/ot-module/schedule-create?schedule_id=" + item_id;
    },

    getSchedule(schedule_id) {

      atshq
          .get("/ot-module/schedule/" + schedule_id)
          .then((response) => {
            this.submitData = response.data.data;
            console.log('ot schedule data', this.submitData.doctor.dr_name)
            this.submitData.counselor = response.data.data.counselor;
          })
          .catch((e) => {
            this.errors = true;
            this.errorMessage = e;
          });
    },
    initialize() {
      atshq
          .get("ot-bill/create?reg_id=" + this.patient_reg_no)
          .then((response) => {
            this.patient_info = response.data.data.patient;
            this.invoices = response.data.data.invoice_list;
            this.doctor = response.data.data.doctor;
            this.operation = response.data.data.operation_details;

            if (response.data.data.operation_details.id == 288) {
              this.eyeTypes = []
            }

            this.op_registration = response.data.data.op_registration;
            this.date = this.op_registration.opp_date;
            this.discount_amount = this.op_registration.discount_amount;
            this.eye_type = response.data.data.op_registration.eye_type;
            this.surgeonList = response.data.data.doctorlist;
            this.loading = false;
            if (this.op_registration.schedule_id) {
              this.getSchedule(this.op_registration.schedule_id);
            }
            this.invoice_total = this.invoices.reduce(
                (acc, item) => acc + parseInt(item.paid_amount),
                0
            );
          })
          .catch((e) => {
            this.errors.push(e);
          });

      atshq
          .get("/payment-methods")
          .then((response) => {
            this.paymentMethods = response.data.data;
          })
          .catch((e) => {
            this.errors = true;
            this.errorMessage = e;
          });
    },
    getOtBill() {
      atshq
          .get("/ot-module/ot-bill-list/" + this.patient_reg_no)
          .then((response) => {
            this.desserts = response.data.data;
          })
          .catch((e) => {
            this.errors = true;
            this.errorMessage = e;
          });
    },
    getPaymentMethod() {
      atshq
          .get("/payment-methods")
          .then((response) => {
            this.paymentMethods = response.data.data;
          })
          .catch((e) => {
            this.errors = true;
            this.errorMessage = e;
          });
    },
    submitForm() {
      if (confirm("are you sure?")) {
        atshq
            .put("ot-registration/" + this.op_registration.registration_no, {
              discount_amount: this.discount_amount,
              date: this.date,
              eye_type: this.eye_type,
              user_id: localStorage.getItem("userId"),
            })
            .then((res) => {
              //Perform Success Action
              if (res.status == "200") {
                this.$noty.success(res.data.messages);
                location.reload();
              }
            })
            .catch((e) => {
              this.$noty.error("Oops, something went wrong!");

              this.errors.push(e);
            })
            .finally(() => {
              //Perform action in always
            });
      }
    },
    receivedMoney() {
      if (confirm("are you sure?"))
        atshq
            .post("ot-bill-receive", {
              formdata: this.form,
              receive_amount: this.receive_amount,
              refund_note: this.refund_note,
              op_reg_id: this.patient_reg_no,
              reg_id: this.patient_reg_no,
              payment_method: this.payment_method,
              user_id: this.user_id,
            })
            .then((response) => {
              this.$noty.success(response.data.message);
              window.open(this.apiBaseUrl + "print/invoice/" + response.data.invoice_id);
              // window.open(this.returnUrl + "printdoc/invoice/" + response.data.invoice_id + "/1");
              location.reload();
            })
            .catch((e) => {
              this.$noty.error("Oops, something went wrong!");

              this.errors.push(e);
            })
            .finally(() => {
              //Perform action in always
            });
    },
    otCancel() {
      if (confirm("are you sure?")) {
        if (this.formdata.reg_no != this.op_registration.registration_no) {
          this.$noty.error("Oops, Please input valid registration no.");
          return false;
        }
        atshq
            .post(
                "ot-module/ot-registration-cancel/" + this.op_registration.registration_no,
                {
                  registration_no: this.formdata.reg_no,
                  description: this.formdata.description,
                  user_id: localStorage.getItem("userId"),
                }
            )
            .then((res) => {
              //Perform Success Action
              if (res.status == "200") {
                this.$noty.success(res.data.messages);

              }
            })
            .catch((e) => {

              this.$noty.error("Oops, something went wrong!");

              this.errors.push(e);
            })
            .finally(() => {
              //Perform action in always
              this.dialog = false;
              this.initialize();
              this.getOtBill();
              this.getPaymentMethod();
            });
      }
    },
    reGenerate() {
      if (this.nowDate != this.op_registration.opp_date) {
        this.$noty.error("Oops, Invalid Request");
        this.$noty.error("Please Try Again!");
        return false;
      }
      if (this.op_registration.registration_no) {
        window.location.href = "/otbill-create/" + this.op_registration.registration_no;
      } else {
        this.$noty.error("Oops, something went wrong!");
        this.$noty.error("Please Try Again!");
      }
    },
    autoGenerate() {
      atshq
          .get(
              "ot-module/ot-bill-auto-gen?reg_id=" + this.op_registration.registration_no,
              {
                registration_no: this.formdata.reg_no,
                description: this.formdata.description,
                user_id: localStorage.getItem("userId"),
              }
          )
          .then((res) => {
            //Perform Success Action
            if (res.status == "200") {
              this.$noty.success(res.data.messages);
              location.reload();
            }
          })
          .catch((e) => {
            this.$noty.error("Oops, something went wrong!");
            this.errors.push(e);
          })
          .finally(() => {
            this.dialog = false;
          });
    },
    discharge_certificate() {
      window.location.href = "/ot-discharge-certificate/" + this.op_registration.schedule_id;
    },
    otbillview() {
      window.open(this.returnUrl + "printdoc/invoiceDoctorOt/" + this.op_registration.registration_no);
    },
    otbill_patient_copy(item) {
      window.open(
          this.returnUrl + "printdoc/invoiceDoctorOtPatient/" + item.registration_no
      );
    },
    getColor(status) {
      if (status == "void") return "red";
      else return "green";
    },
  },
  filters: {
    currency(value) {
      return value.toFixed(2);
    },
  },
};

</script>
